import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

export function AdminRoute({ children }) {
  const currentUser = useSelector((state) => state.auth?.currentUser);

  if (!currentUser || currentUser.userType !== 0) {
    return <Navigate to="/" replace />;
  }

  return children;
}
